export default "__VITE_ASSET__DR9sPCg2__"